import React, { ReactNode } from 'react';

// Material ui
import {
    Dialog as MaterialModal,
    DialogTitle,
    Grid
} from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import IconButton from '@components/UI-KIT/IconButton';

// Icons
import { Close } from '@/assets/icons';

// Styles
import VARIABLES from '@/assets/variables.ts';
import './Modal.scss';

interface Props {
    children: ReactNode;
    title?: string;
    open: boolean;
    closeModal: () => void;
    className?: string;
    text?: string | ReactNode;
}
const Modal: React.FC<Props> = ({
    open,
    children,
    title,
    closeModal,
    className,
    text
}) => {

    return (
        <MaterialModal
            classes={{
                root: 'ui-Modal-root-component',
                paper: `ui-Modal-component-container${className ? ` ${className}` : ''}`
            }}
            open={open}
        >
            <Grid
                container
                justify="space-between"
                className="ui-Modal-title"
            >
                <Grid
                    item
                    xs={11}
                >
                    <DialogTitle>
                        <Typography
                            variant="h3"
                            color="primary-dark"
                        >
                            {title}
                        </Typography>
                    </DialogTitle>
                </Grid>
                <Grid
                    item
                    container
                    justify="flex-end"
                    xs={1}
                >
                    <IconButton
                        onClick={closeModal}
                    >
                        <Close
                            color={VARIABLES.palette.secondary_color}
                        />
                    </IconButton>
                </Grid>
            </Grid>
            { text && typeof text === 'string' ? (
                <Typography
                    className="ui-Modal-component-text"
                >
                    {text}
                </Typography>
            ) : text}
            {children}
        </MaterialModal>
    );
};

export default Modal;